import store from "@/store"
export const hasGlobalBrand = (to, from, next) => {
  if (!store.state.globalBrand?.id) {
    // If there is only 1 brand, automatically set this one as the global brand
    if (store.state.brands.length == 1) {
      store.commit("setGlobalBrand", store.state.brands[0])
      return next()
    }
    store.commit(
      "warning",
      "You must select a brand before creating a new product"
    )
    return next(false)
  } else if (!store.state.globalBrand?.brand_id) {
    store.commit(
      "warning",
      "This brand is pending approval, you can't create a product for it yet"
    )
    return next(false)
  } else return next()
}
export const requireAuth = (to, from, next) => {
  if (!store.state.user?.key) {
    return next({
      path: "signin",
      query: { redirect: to.fullPath }
    })
  } else return next()
}

export const requireAdmin = (to, from, next) => {
  if (store.getters.isUserAdmin) return next()
  else
    return next({
      name: "Accueil"
    })
}

export const requireCreateProductRights = (to, from, next) => {
  if (
    store.getters.isUserAdmin ||
    store.getters.isBrandUser ||
    store.getters.isContributor
  )
    return next()
  else
    return next({
      name: "Accueil"
    })
}

export const requireBrandRights = (to, from, next) => {
  if (store.getters.isUserAdmin || store.getters.isBrandUser) return next()
  else
    return next({
      name: "Accueil"
    })
}

export const requireMergeDuplicates = (to, from, next) => {
  if (store.getters.canMergeDuplicates) return next()
  else
    return next({
      name: "Accueil"
    })
}
